import React from 'react'

import { Grid, Item } from 'core-components/library/grid'

import { List } from './descriptionLists/List'

interface IProps {
  className?: string
  software: { name: string }[]
  areasOfFocus: { name: string }[]
  noData: any
  categories: any
}

export const DescriptionLists = ({
  className,
  software,
  areasOfFocus,
  noData,
  categories,
}: IProps) => {
  const setSource = (groupName: string) => {
    if (noData) {
      return []
    }
    return (
      (categories &&
        categories
          .filter((item: any) => item.tag_group.toLowerCase().replace(/\s+/g, '') === groupName)
          .sort((a: any, b: any) => a.id - b.id)) ||
      []
    )
  }

  return (
    <div className={className || ''}>
      <Grid gap={16}>
        <Item xs={12} md={4}>
          <List
            title={'partnerpreview-specialized-in'}
            selectedValues={areasOfFocus}
            dataSource={setSource('industries')}
          />
        </Item>

        <Item xs={12} md={4}>
          <List
            title={'partnerpreview-software'}
            selectedValues={software}
            dataSource={setSource('software')}
          />
        </Item>
      </Grid>
    </div>
  )
}
